import { Translate } from '@chipinside/translate'

interface IParams {
  fileURL?: string
  format_file: string
}

export const buildTemplateInstructions = ({ fileURL, format_file }: IParams) => [
  {
    label: Translate({ messageKey: 'download_template_spreadsheet' }),
    link: `${import.meta.env.VITE_API_URL}/${fileURL}`,
  },
  {
    label: Translate({ messageKey: 'fill_all_required_fields' }),
  },
  {
    label: Translate({
      messageKey: 'save_file_in_format',
      params: { format: format_file },
    }),
  },
  {
    label: Translate({ messageKey: 'upload_file_through_field_below' }),
  },
]
